export const FORMATIVE_REPORTS_PAGE_TYPE = {
  APPROVALS: 'APPROVALS',
  CHILD: 'CHILD',
  LEARNING: 'LEARNING',
}
